<template>
  <div class="XVcheckboxlist checkboxlist pointer">
    <template v-if="labelAlignTop">
      <span
        v-focus="focus"
        v-for="(listitem, index) in datalist"
        :key="index"
        class="hzlistholder labelAlignTop"
        v-on:click="clickcheck(index)"
      >
        <div v-if="headersVisible" class="pointer">{{ listitem.labelText }}</div>
        <div class="squaredFour pointer">
          <input :disabled="disabled" :checked="checkedindex[index]" type="checkbox" />
          <label></label>
        </div>
      </span>
    </template>
    <template v-if="!labelAlignTop">
      <div
        v-focus="focus"
        v-for="(listitem, index) in datalist"
        :key="index"
        class="hzlistholder"
        v-on:click="clickcheck(index)"
      >
        <div class="squaredFour pointer">
          <input :disabled="disabled" :checked="checkedindex[index]" type="checkbox" />
          <label></label>
        </div>
        <label v-if="headersVisible" class="radiolabel pointer">{{ listitem.labelText }}</label>
      </div>
    </template>
    <!-- <span>{{$v}}</span> -->
  </div>
</template>

<script>
export default {
  name: 'XVcheckboxlist',
  props: {
    focus: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    datalist: {
      type: Array,
      reuired: true,
    },
    value: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formdata: {},
    labelAlignTop: {
      type: Boolean,
      default: false,
    },
    headersVisible: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      checkedindex: [],
    }
  },
  watch: {
    value: function () {
      this.checkedindex = []
      this.datalist.forEach((val, i) => {
        let checked = this.value === null ? [] : this.value.filter((n) => String(n) === String(val.value))

        if (checked.length === 0) {
          this.checkedindex.push(false)
        } else {
          this.checkedindex.push(true)
        }
      })
    },
  },
  methods: {
    clickcheck: function (checked) {
      if (this.disabled === true) {
        return false
      }
      this.checkedindex[checked] = !this.checkedindex[checked]

      let formvalues = []
      this.checkedindex.forEach((val, index) => {
        if (val === true) {
          formvalues.push(this.datalist[index].value)
        }
      })

      this.$emit('input', formvalues) // prop value en deze input event handler zorgen er voor dat je een v-model kan toepassen op dit custom component
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: formvalues,
        id: this.id,
        formdata: this.formdata,
      })
    },
  },
  mounted: function () {
    this.checkedindex = []
    this.datalist.forEach((val, i) => {
      let checked = this.value.filter((n) => String(n) === String(val.value))

      if (checked.length === 0) {
        this.checkedindex.push(false)
      } else {
        this.checkedindex.push(true)
      }
    })
  },
}
</script>
<style>
.hzlistholder {
  display: inline;
  margin-right: 20px;
}
.labelAlignTop {
  display: inline-block;
  text-align: center;
}
</style>
